import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon ,MDBRow, MDBCol,MDBDataTable, MDBTabPane,
    MDBTabContent, MDBNav,
    MDBNavItem,
    MDBNavLink } from 'mdbreact';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
//import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';
import Superadminlistarticalgroup from './superadminlistarticalgroup';



export default class superadminlistartical extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            activeItem: "1",
            presentationtype:[],
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.toggle = this.toggle.bind(this);
      }

      toggle = tab => e => {
        if (this.state.activeItem !== tab) {
          this.setState({
            activeItem: tab
          });
        }
      };


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          api.get('registercon/selecttpresentationtypenum')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ presentationtype: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectregisterall')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {



      const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อ-นามสกุล',
            field: 'register_pname',
            sort: 'register_pname',
            width: 150
          },
          {
            label: 'เบอร์โทร',
            field: 'register_phone',
            sort: 'register_phone',
            width: 150
          },
          {
            label: 'อีเมลล์',
            field: 'register_email',
            sort: 'register_email',
            width: 150
          },
      
        
        ],
  
  
        rows: [...this.state.article.map((data, i) => (
      
          {
     
  
             list: <>{i+1}</>,
             register_pname: <>{data.register_pname}{data.register_nameth} {data.register_lnameth}</>,
             register_phone: <>{data.register_phone}</>,
             register_email: <>{data.register_email}</>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อ-นามสกุล"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
             theadColor="grey lighten-1"
          //  theadColor={"#ff4444"}
            />



        return (
            <MDBContainer fluid>
            <div>
             {localStorage.getItem('nameuser') === 'admindype1' ?<>
              <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} ผู้ดูแลระบบประเภท {localStorage.getItem('presentype_name')}</p>
             </>:<>
              <p className="text-right font-weight-bold">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
             </>}
           
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
         
            <MDBAlert color="secondary" >
                   {/* <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ทรงคุณวุฒิ</h2> */}
      
                     <MDBRow >
                    <MDBCol md="8">
                    <PageHeader
                        className="site-page-header"
                       // onBack={() => null}
                        title="บทความแต่ละกลุ่ม"
                        subTitle="บทความแต่ละกลุ่ม"
                        avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/3456/3456388.png' }}
                    />
                    </MDBCol>
                    <MDBCol md="4">
                      {/* <p> hjkjk</p>  */}
                    </MDBCol>
                    </MDBRow>
                  
   </MDBAlert>
   <p className='font-weight-bold'>ผู้ลงทะเบียนทั้งหมดแต่ละกลุ่ม</p>
   {/* <Badge count={99} /> หมายถึง ยังดำเนินการไม่เสร็จสิ้น */}
   <MDBNav className="nav-tabs mt-2">
           {this.state.presentationtype.map((presentationtype,index )  => 
           
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === presentationtype.presentype_id} onClick={this.toggle(presentationtype.presentype_id)} role="tab" >
              {presentationtype.presentype_name} {presentationtype.Numon > 0 ?<><Badge count={presentationtype.Numon} /></>:<></>} 
            </MDBNavLink>
          </MDBNavItem>
           )}


          {/* <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggle("2")} role="tab" >
              Profile
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "3"} onClick={this.toggle("3")} role="tab" >
              Profile
            </MDBNavLink>
          </MDBNavItem> */}
        </MDBNav>

        <MDBTabContent activeItem={this.state.activeItem} >
        {this.state.presentationtype.map((presentationtype,index )  => 
          <MDBTabPane tabId={presentationtype.presentype_id} role="tabpanel">
            {/* <p className="mt-2">
          
            </p> */}
          <Superadminlistarticalgroup presentype_id={presentationtype.presentype_id} presentype_name={presentationtype.presentype_name} />
          </MDBTabPane>
         )}

          {/* <MDBTabPane tabId="2" role="tabpanel">
            <p className="mt-2">
              Quisquam aperiam, pariatur. Tempora, placeat ratione porro
              voluptate odit minima. Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Nihil odit magnam minima,
              soluta doloribus reiciendis molestiae placeat unde eos
              molestias.
            </p>
            <p>
              Quisquam aperiam, pariatur. Tempora, placeat ratione porro
              voluptate odit minima. Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Nihil odit magnam minima,
              soluta doloribus reiciendis molestiae placeat unde eos
              molestias.
            </p>
          </MDBTabPane>
          <MDBTabPane tabId="3" role="tabpanel">
            <p className="mt-2">
              Quisquam aperiam, pariatur. Tempora, placeat ratione porro
              voluptate odit minima. Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Nihil odit magnam minima,
              soluta doloribus reiciendis molestiae placeat unde eos
              molestias.
            </p>
          </MDBTabPane> */}
        </MDBTabContent>
                   {/* {persons}  */}

            </div>
            </MDBContainer>
        )
    }
}
